import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ScheduleTask extends ValueObject {
    
    public command: string = "";

    public scheduledDateTime: Date | null = null;

    public executionDateTime: Date | null = null;

    public executionCompleteDateTime: Date | null = null;
}